<!-- Button -->
<button mat-icon-button [matTooltip]="tooltip || 'Toggle Fullscreen'" (click)="toggleFullscreen()">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon style="width: 18px !important; height: 18px !important; min-width: 18px; min-height: 18px;"
        [svgIcon]="'fullscreen'"></mat-icon>
</ng-template>